import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import ContentContainer from "../components/ContentContainer";
import MainContainer from "../components/MainContainer";
import MakeGetRequest from "../components/utils/MakeGetRequest";
import { setToken } from "../store"; // Import the action from your store
import Layout from "../layouts/LayoutDefault";

const VerifyMailPage = () => {
  const [verifed, setVerifed] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const verificationToken = queryParams.get("token");
  const mailUpdate = queryParams.get("update");

  const { data: responseData, error: errorMsg } = MakeGetRequest({
    route: `verify_email?token=${verificationToken}`,
  });

  useEffect(() => {
    if (responseData && !verifed) {
      dispatch(setToken());
      setVerifed(true); // Mark the user as logged in after email verification
      const timer = setTimeout(() => {
        if (mailUpdate) {
          navigate("/login"); // Redirect to login if mailUpdate is true
        } else {
          navigate("/userprofile"); // Redirect to user profile
        }
      }, 5000); // Wait 5 seconds before redirecting

      return () => clearTimeout(timer); // Cleanup on unmount
    }
  }, [responseData, dispatch, verifed, mailUpdate, navigate]);

  return (
    <>
      <Layout title="Verifiera Epost">
        <MainContainer>
          <ContentContainer>
            {errorMsg && !verifed && (
              <h3 className="text-xl text-error">{errorMsg}</h3>
            )}
            {responseData &&
              (mailUpdate ? (
                <h3 className="text-xl text-success">
                  Ditt e-postadress är uppdaterad. Du får nu logga in med din
                  nya adress.
                </h3>
              ) : (
                <h3 className="text-xl text-success">
                  Välkommen till Lokult, du blir snart förflyttad till din
                  profilsida.
                </h3>
              ))}

            {!responseData ||
              (!errorMsg && (
                <h3 className="text-xl text-white">
                  Försöker bekräfta kontot, håll i hatten...
                </h3>
              ))}
          </ContentContainer>
        </MainContainer>
      </Layout>
    </>
  );
};

export default VerifyMailPage;
